import React, { useEffect, lazy } from "react";
import { Col, Row, Form, Input } from "antd";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import "./../../styles/modal.css";
import { FiPlusCircle } from "react-icons/fi";
import MeshBillModal from "../Items/Modal/Index";
import MeshBillSelect from "../Items/Select/Index";
import MeshBillButton from "../Items/Button/Index";

// const MeshBillModal = lazy(() => import("../Items/Modal/Index"));
// const MeshBillButton = lazy(() => import("../Items/Button/Index"));
// const MeshBillSelect = lazy(() => import("../Items/Select/Index"));

const CreateNewRadiusChildProbeModalComponent: React.FC<
  CreateNewRadiusChildProp
> = ({ show, handleClose, intPkMeshBillRadiusProbeID }) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<CreateNewChildRadiusApiProp>(
    "radiusProbes/createNewChildProbe",
    true
  );

  const onFinish = (values: any) => {
    const dataToSend: CreateNewChildRadiusApiProp = {
      intPkMeshBillRadiusProbeID: intPkMeshBillRadiusProbeID,
      port: Number(values.port),
      portType: values.portType,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <MeshBillModal
        title="Create Radius Probe Child"
        headerStyle={{
          backgroundColor: "var(--primary-background-color)",
          color: "var(--primary-text-color)",
          fontSize: "16px",
          fontWeight: "var(--fw-700)",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col
            span={24}
            className="meshbill-create-record-modal-form-container"
          >
            <Form
              //   requiredMark={true}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="createNewRadiusChildForm"
              form={form}
            >
              <Form.Item
                label={<span className="create-user-form-label">Port</span>}
                name="port"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Child Port",
                  },
                  {
                    validator: (_, value) =>
                      value >= 1000
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error("Port Number should be greater than 1000")
                          ),
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="7120"
                  type="number"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="create-user-form-label">Port Type</span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please Select Port Type",
                  },
                ]}
                name="portType"
              >
                <MeshBillSelect
                  size="large"
                  height="45px"
                  options={[
                    { label: "Auth Port", value: "AUTH" },
                    { label: "Accounting Port", value: "ACCOUNTING" },
                  ]}
                />
              </Form.Item>

              <Form.Item>
                <MeshBillButton
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Create New child Probe"
                  disabled={apiLoading}
                  icon={<FiPlusCircle />}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </MeshBillModal>
    </>
  );
};
export default CreateNewRadiusChildProbeModalComponent;
